import { render, staticRenderFns } from "./store-detail.vue?vue&type=template&id=78d04adb&scoped=true&"
import script from "./store-detail.vue?vue&type=script&lang=js&"
export * from "./store-detail.vue?vue&type=script&lang=js&"
import style0 from "./store-detail.vue?vue&type=style&index=0&id=78d04adb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d04adb",
  null
  
)

export default component.exports